import React, { createContext, useState, useRef } from 'react';
import config from '../../settings/config';

export const AudioPlayerContext = createContext();

export const AudioPlayerProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const audioRef = useRef(null);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <AudioPlayerContext.Provider value={{ isPlaying, togglePlay, audioRef }}>
      {children}
      <audio ref={audioRef} src={`/player/live`} />
    </AudioPlayerContext.Provider>
  );
};
